import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "game-list" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "mt-2" }
const _hoisted_4 = { class: "text-capitalize-first" }
const _hoisted_5 = { class: "games-wrapper ms-0 me-0" }
const _hoisted_6 = { class: "mt-2" }
const _hoisted_7 = { class: "text-capitalize-first" }
const _hoisted_8 = { class: "games-wrapper ms-0 me-0" }

import PopupWrapper from "@/components/PopupWrapper.vue";
import {reactive} from "@vue/reactivity";
import {ref} from "vue";
import LoaderContent from "@/components/LoaderContent.vue";
import {useStore} from "vuex";
import GameIcon from "@/components/games/GameIcon.vue";
import PaginatedResponseDTO from "@/models/PaginatedResponseDTO";
import GameDTO from "@/models/GameDTO";
import {api} from "@/service/APIClient";


export default /*@__PURE__*/_defineComponent({
  __name: 'SelectGameToPlayPopup',
  setup(__props, { expose: __expose }) {

const loader = ref<InstanceType<typeof LoaderContent> | null>(null)
const store = useStore();
const state = reactive({
  isShown: false,
  games: {
    limit: 100,
    offset: 0,
    totalCount: 0,
    items: []
  } as PaginatedResponseDTO<GameDTO>,
})

const show = () => {
  state.isShown = false;
  popup.value?.show()
}

const onShown = () => {
  if (state.isShown) {
    return
  }

  state.isShown = true;
  loader.value?.load(async () => {
    [state.games] = await Promise.all([
      api.call.games.list(state.games),
    ])
  });
}

const hide = () => {
  popup.value?.hide()
}

const beforePlay = async () => {
  popup.value?.hide()
}

__expose({ show, hide })
const popup = ref<InstanceType<typeof PopupWrapper> | null>(null)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PopupWrapper, {
    title: _ctx.$t('select_game_to_play'),
    ref: (el) => popup.value = el,
    class: "popup-float",
    "hide-close-btn": false
  }, {
    default: _withCtx(() => [
      _createVNode(LoaderContent, {
        ref: (el) => {loader.value = el; onShown()}
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_unref(store).getters.favoriteGames.length !== 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t('favorite_games')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).getters.favoriteGames, (game, index) => {
                      return (_openBlock(), _createBlock(GameIcon, {
                        "hide-fav": true,
                        beforePlay: beforePlay,
                        key: game.id,
                        game: game
                      }, null, 8, ["game"]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.$t('games')), 1)
              ]),
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).games.items, (game, index) => {
                  return (_openBlock(), _createBlock(GameIcon, {
                    "hide-fav": true,
                    beforePlay: beforePlay,
                    key: game.id,
                    game: game
                  }, null, 8, ["game"]))
                }), 128))
              ])
            ])
          ])
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})